var map = {
	"./Dots.svg": 206,
	"./Illustration-Error.svg": 314,
	"./MicPermissionsDialogImage.svg": 315,
	"./PlayIcon.svg": 207,
	"./addhero.16.svg": 316,
	"./fonts/Bahnschrift.woff": 317,
	"./icon-16.png": 318,
	"./icon-32.png": 319,
	"./icon-80.png": 320,
	"./logo-filled.png": 321,
	"./ping_image.png": 322,
	"./transcription_signal_indicator.png": 323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;